// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root___IFmb","list":"PatternAutocomplete_list__31Uaq"};